import { render } from "./Key.vue?vue&type=template&id=2a00d4ae"
import script from "./Key.vue?vue&type=script&lang=js"
export * from "./Key.vue?vue&type=script&lang=js"

import "./Key.vue?vue&type=style&index=0&id=2a00d4ae&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__